export enum SelectedPriceCatergoryDefault {
    NORMAL_PRICE = "normal_price",
    CHEAPEST = "cheapest",

    CUSTOM = "custom"
}
